import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'
import { ColumnAdapter } from '@makyoapp/makyo-common'
import { SelectDropdown, SimpleInput } from '@makyoapp/makyo-ui'

import { useDbClientContext } from '@/context/__project__/DbClientContext'

import { RenderColumn } from './RenderColumn'

interface SlugColumnDropdownProps {
  tableId: string
  value: string
  onChange: (value: string) => void
}

export const SlugColumnDropdown = ({ tableId, onChange, value }: SlugColumnDropdownProps) => {
  const { tables } = useDbClientContext()

  const table = tables.find((t) => t.id === tableId)

  if (!table) return null

  const slugColumnOptions = table.columns.filter((c) => c.type === ColumnTypes.Slug)

  return (
    <SelectDropdown
      multiple={false}
      options={slugColumnOptions}
      optionLabel={(opt) => opt.name}
      value={slugColumnOptions.find((column) => column.id === value)}
      renderOption={(opt) => <RenderColumn withStyle={false} col={opt as ColumnAdapter} />}
      onChange={(column) => {
        onChange(column.id)
      }}
    />
  )
}
